module.exports = __webpack_public_path__ + "static/media/icon-left.6f6a5b9d.svg";